import { Avatar ,AvatarBadge} from "@chakra-ui/avatar";
import { Box, Text } from "@chakra-ui/layout";
import { Divider} from "@chakra-ui/react";
// import IsOnlineBadge from "../misc/chatisOnlinebadge";

const UserListItem = ({  user , handleFunction }) => {
//   const { user } = ChatState();
console.log('user isOnline status: ',user)
  return (
    <Box
  
      onClick={handleFunction}
      cursor="pointer"
      // bg="#E8E8E8"
      // _hover={{
      //   background: "#38B2AC",
      //   color: "white",
      // }}
      bg={"bgs.userBtn"}
            color={"bgs.chtBtnTxt"}
            // border={"brd.userBtn"}
            _hover={{
              background: "rgba(51, 117, 218, 0.5)",
              color: "#fff",
              border:"brd.userBtnSel"
        }}
      border={user.isOnline? 'limegreen':"brd.chtBtn"}
      w="100%"
      display="flex"
      alignItems="center"
      color="black"
      px={3}
      py={2}
      mb={2}
      // borderRadius="lg"
      boxShadow={"bxshd.inset_lt_bl"}
      borderRadius="0 10px 0 15px"
      
    >
    
      {/* <IsOnlineBadge isOnline={user.isOnline} > */}
       <Avatar
        mr={2}
        size="sm"
        cursor="pointer"
        name={user.preferredName}
        src={user.pic}
        border={user.isOnline?'3px solid limegreen':'2px solid orange'}

      >
      <AvatarBadge 
        h={'15px'}
        w={'15px'}
        border={'1px solid white'}
        zIndex={1000}
        borderRadius={'100%'}
        backgroundColor={user.isOnline?'limegreen':'orange'}
        />
     
      </Avatar>
      {/* </IsOnlineBadge> */}
      <Divider borderColor={'#868686'}  orientation='vertical'/>
      <Box>
        <Text>{user.preferredName}</Text>
      <Divider borderColor={'#868686'} orientation='horizontal'/>
        <Text fontSize="xs">
          <b>Email : </b>
          {user.email}
        </Text>
      </Box>
    </Box>
  );
};

export default UserListItem;